import React from 'react'
import styles from "styles/pages/Pages.module.scss";
import ChevronLeftRoundedIcon from '@mui/icons-material/ChevronLeftRounded';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import { RenderPuesto } from './RenderPuesto';

export const RenderPosta = (posta, rowPosition, getChildren, hanndleSelectId, toggleExpand, expanded, id) => {
        const puestos = getChildren(posta.id, "puesto");
        const isExpanded = expanded[posta.id];
        const hasChildren = puestos.length > 0;

        return (
            <React.Fragment key={posta.id}>
                <div 
                    className={`${styles.containerDivInfo} ${posta.id === id && styles.select} ${styles.postaColor}`}
                    style={{ gridColumn: '6', gridRow: rowPosition }}
                    onClick={() => hanndleSelectId(posta.id)}
                >
                    <div className={styles.divText}>
                        {hasChildren && (
                            <div onClick={(e) => toggleExpand(posta.id, e)}>
                                {isExpanded ? 
                                    <ChevronRightRoundedIcon size={20} /> : 
                                    <ChevronLeftRoundedIcon size={20} />
                                }
                            </div>
                        )}
                        <span className={styles.divName}>{posta.name}</span>
                    </div>
                </div>
                {isExpanded && puestos.map((puesto, idx) => RenderPuesto(puesto, rowPosition + idx), hanndleSelectId, id)}
            </React.Fragment>
        );
    };
